import React, { useState } from "react";
import {
	makeStyles,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	IconButton,
} from "@material-ui/core";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";

const useStyles = makeStyles((theme) => ({
	table: {
		"& tbody": {
			"& th,td": {
				fontWeight: "normal",
			},
		},
	},
	dragHandle: {
		cursor: "grab",
		"&:active": {
			cursor: "grabbing",
		},
	},
	sortableRow: {
		backgroundColor: theme.palette.background.paper,
		"&.sortable-helper": {
			boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
			zIndex: 9999,
		},
	},
}));

const DragHandle = SortableHandle(() => {
	const classes = useStyles();
	return (
		<IconButton size="small" className={classes.dragHandle}>
			<DragHandleIcon />
		</IconButton>
	);
});

const SortableRow = SortableElement(({ row, classes }) => (
	<TableRow className={classes.sortableRow}>
		<TableCell align="left" style={{ width: 60 }}>
			<DragHandle />
		</TableCell>
		<TableCell align="left" style={{ width: 60 }}>
			{row.orderNum}
		</TableCell>
		<TableCell align="left">{row.questionText}</TableCell>
		<TableCell align="left">{row.answerText}</TableCell>
		{row.image && row.image !== "" && (
			<TableCell align="left">
				<img
					src={row.image}
					style={{ width: 100, height: 100, objectFit: "cover" }}
					alt={"Question image"}
				/>
			</TableCell>
		)}
	</TableRow>
));

const SortableTableBody = SortableContainer(({ children }) => (
	<TableBody>{children}</TableBody>
));

const PreEnteredRoundQuestions = ({ questions, onReorder }) => {
	const classes = useStyles();
	const [localQuestions, setLocalQuestions] = useState(questions);

	const onSortEnd = ({ oldIndex, newIndex }) => {
		if (oldIndex === newIndex) return;

		const reorderedQuestions = [...localQuestions];
		const [movedItem] = reorderedQuestions.splice(oldIndex, 1);
		reorderedQuestions.splice(newIndex, 0, movedItem);

		// Update order numbers
		const updatedQuestions = reorderedQuestions.map((q, idx) => ({
			...q,
			orderNum: idx + 1,
		}));

		setLocalQuestions(updatedQuestions);

		// Call parent callback if provided
		if (onReorder) {
			onReorder(updatedQuestions);
		}
	};

	return (
		<TableContainer>
			<Table
				className={classes.table}
				style={{ tableLayout: "fixed" }}
				aria-label="sortable questions table"
			>
				<TableHead>
					<TableRow>
						<TableCell width={60} align="left"></TableCell>
						<TableCell width={60} align="left">
							№
						</TableCell>
						<TableCell align="left">Questions</TableCell>
						<TableCell align="left">Answers</TableCell>
					</TableRow>
				</TableHead>
				<SortableTableBody
					onSortEnd={onSortEnd}
					useDragHandle
					lockAxis="y"
					helperClass="sortable-helper"
				>
					{localQuestions.map((row, index) => (
						<SortableRow key={`question-${row.id || index}`} index={index} row={row} classes={classes} />
					))}
				</SortableTableBody>
			</Table>
		</TableContainer>
	);
};

export default PreEnteredRoundQuestions;
